import UserProfile from "../../../components/cm/Dashboard/FullPages/UserManager/UserProfile";

export default () => {
  return <UserProfile />;
};
